import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FilesService } from 'src/app/modules/files/services/files/files.service';
import { Logger } from 'projects/common/src/app/classes';

@Component({
  selector: 'app-report-front-modal',
  templateUrl: './report-front-modal.component.html',
  styleUrls: ['./report-front-modal.component.scss'],
})
export class ReportFrontModalComponent extends Logger implements OnInit {
  public imageUrl: SafeUrl;

  @Input()
  public image: any;

  @Input()
  public title: string;

  @Input()
  public fileGuid: string;

  @Input()
  public date: string;

  @Input()
  public userFullName: string;

  @Input()
  public detail: string;

  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer, private fileService: FilesService) {
    super();
  }

  /**
   * On init component.
   */
  public ngOnInit(): void {
    const unsafeImageUrl = URL.createObjectURL(this.image);
    this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
  }

  /**
   * Function to download modal image.
   */
  public async downloadImage(): Promise<void> {
    try {
      await this.fileService.downloadFile(this.fileGuid, this.fileGuid);
    } catch (error) {
      this.error(error.message);
    }
  }
}
